/*
 * @Descripttion:
 * @version:
 * @Author: wanglong
 * @Date: 2021-07-16 17:21:42
 * @LastEditors: wanglong
 * @LastEditTime: 2021-07-16 18:00:31
 * @* : 博虹出品，抄袭必究😄
 */
import request from "@/plugins/axios";

//下载
export function download(id) {
  return request({
    url: "/web/download?value=" + id,
    method: "get",
    responseType: "blob",
  });
}

//下载
export function webGet() {
  return request({
    url: "/web/get",
    method: "get",
  });
}
